import React from 'react'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect w="100%" selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView w="100%">
          <MobileScreen>
            <CFLink
              target="_blank"
              href="https://goo.gl/maps/fBnkrc2FpUwpnvEm7"
            >
              <CFImage
                src={mobileMap}
                w="100%"
                alt="Masa Japanese Restaurant Map"
              />
            </CFLink>
          </MobileScreen>
          <DefaultScreen>
            <CFLink
              column
              center
              maxWidth="1400px"
              w="100%"
              target="_blank"
              href="https://goo.gl/maps/fBnkrc2FpUwpnvEm7"
            >
              <CFImage
                src={locationMap}
                style="display: block"
                w="100%"
                alt="Masa Japanese Restaurant Kitchen Map"
              />
            </CFLink>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
